module.exports = __webpack_public_path__ + "img/dog-office-md.c0eb9497.jpg";